import { makeAutoObservable } from "mobx";
import { BreadcrumbItem } from "src/appStore";
import { loadCatalog } from "src/business/catalog/apiCatalog";
import { ZCatalog } from "src/business/catalog/ZCatalog";
import {
  loadCatalogRecord,
  updateCatalogRecord,
} from "src/business/records/apiRecords";
import { getRecordTitle } from "src/business/records/getRecordTitle";
import {
  ZCatalogRecord,
  ZCatalogRecordToSave,
} from "src/business/records/ZCatalogRecord";
import { RemoteData } from "src/common/RemoteData";
import { submitMForm } from "src/components/MForm/submitMForm";
import { PageUrl } from "src/routes/PageUrl";

import { CDSFormStore } from "../CatalogRecordForm/CDSFormStore";
import {
  CatalogRecordFormContext,
  createCatalogRecordFormLoader,
} from "../CatalogRecordForm/createCatalogRecordFormLoader";

export type CatalogCardData = {
  record: ZCatalogRecord;
  catalog: ZCatalog;
};

export const catalogCardStore = makeAutoObservable({
  async init(recordId: string) {
    this.setRecordId(recordId);
    try {
      this.setData({ status: "wait" });
      const record = await loadCatalogRecord(recordId);
      const { catalogId } = record;
      if (!catalogId) {
        throw Error("Отсутствует catalogId");
      }
      const catalog = await loadCatalog(catalogId);
      this.setData({
        status: "ready",
        result: { record, catalog },
      });
      this.setCDSFormStore(
        new CDSFormStore(createCatalogRecordFormLoader(catalog), { record }),
      );
    } catch (error) {
      this.setData({ status: "error", error });
    }
  },
  recordId: "",
  setRecordId(id: string) {
    this.recordId = id;
  },
  data: { status: "none" } as RemoteData<CatalogCardData>,
  setData(newData: RemoteData<CatalogCardData>) {
    this.data = newData;
  },
  cdsFormStore: null as CDSFormStore<CatalogRecordFormContext> | null,
  setCDSFormStore(store: CDSFormStore<CatalogRecordFormContext>) {
    this.cdsFormStore = store;
  },
  get breadcrumbs(): BreadcrumbItem[] {
    const items: BreadcrumbItem[] = [
      { title: "Каталоги", page: PageUrl.catalogs },
    ];
    const { data } = this;
    if (data.status === "ready") {
      const { catalog } = data.result;
      items.push({
        title: catalog.name,
        page: PageUrl.records,
        params: { id: catalog.id },
      });
      items.push({ title: this.title });
    }
    return items;
  },
  get title(): string {
    const { data } = this;
    return data.status === "ready" ? getRecordTitle(data.result.record) : "...";
  },
  async submit(values: ZCatalogRecordToSave) {
    const { data, cdsFormStore } = this;
    if (data.status !== "ready" || !cdsFormStore)
      throw Error("Данные недоступны");
    const record = await submitMForm(
      () => updateCatalogRecord(data.result.record.id, values),
      cdsFormStore.errorsStore,
    );
    this.setData({ status: "ready", result: { ...data.result, record } });
    cdsFormStore.setContext({ record });
    await cdsFormStore.reload();
    return record;
  },
  deleting: false,
  setDeleting(value: boolean) {
    this.deleting = value;
  },
});
